import ApplicationAdapter from "./application";

export default class ApiKeyAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/apikey/create`;
  }

  urlForUpdateRecord() {
    return `${this.apiBaseUri}/apikey/edit`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/apikey/delete?apikey=${id}`;
  }
}
